export default __webpack_public_path__ + "static/media/footer-background.44f0a302.webp";